/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const leaf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m1 12.53 1.692-1.467m0 0c.226.475.53.912.904 1.292A4.65 4.65 0 0 0 6.91 13.75c3.935 0 9.116-4.082 7.914-11.233a.32.32 0 0 0-.34-.266.287.287 0 0 0-.144.058c-3.94 3.32-12.116-.225-12.116 6.68 0 .725.163 1.433.468 2.074Zm0 0c1.443-1.25 3.045-2.25 4.808-2.924"
    />
  </svg>
)
export default leaf
